import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const AUTH_ORGANIZATION_LANG: {
  AUTH_ORGANIZATION_NOUN: MvnCodeFE;
  AUTH_ACCEPTED_NOUN: MvnCodeFE;
  AUTH_REJECTED_NOUN: MvnCodeFE;
  AUTH_CANCEL_INVITATION_NOUN: MvnCodeFE;

  AUTH_ORG_TAB_ORGANIZATION_LIST: MvnCodeFE;
  AUTH_ORG_TAB_INVITE: MvnCodeFE;

  AUTH_ORG_INVITATION_EMPTY_TITLE: MvnCodeFE;

  AUTH_ORG_INVITATION_POPUP_TITLE: MvnCodeFE;
  AUTH_ORG_INVITATION_POPUP_DESC: MvnCodeFE;

  AUTH_ORG_INVITATION_CANCEL_TITLE: MvnCodeFE;
  AUTH_ORG_INVITATION_CANCEL_DESC: MvnCodeFE;

  AUTH_ORG_EMPTY_TITLE: MvnCodeFE;
  AUTH_ORG_EMPTY_DESC: MvnCodeFE;

  AUTH_ORG_CREATE_TITLE: MvnCodeFE;
  AUTH_ORG_CREATE_ORGANIZATION_LABEL: MvnCodeFE;
  AUTH_ORG_CREATE_ORGANIZATION_PLACEHOLDER: MvnCodeFE;
  AUTH_ORG_CREATE_SUCC: MvnCodeFE;
  AUTH_ORG_CREATE_FAIL: MvnCodeFE;

  AUTH_ORG_RENAME_TITLE: MvnCodeFE;
  AUTH_ORG_RENAME_ORGANIZATION_LABEL: MvnCodeFE;
  AUTH_ORG_RENAME_ORGANIZATION_PLACEHOLDER: MvnCodeFE;
  AUTH_ORG_RENAME_SUCC: MvnCodeFE;
  AUTH_ORG_RENAME_FAIL: MvnCodeFE;

  AUTH_ORG_DELETE_TITLE: MvnCodeFE;
  AUTH_ORG_DELETE_DESC1: MvnCodeFE;
  AUTH_ORG_DELETE_DESC2: MvnCodeFE;
  AUTH_ORG_DELETE_SUCC: MvnCodeFE;
  AUTH_ORG_DELETE_FAIL: MvnCodeFE;

  AUTH_ORG_DELETE_CONFIRM_TITLE: MvnCodeFE;
  AUTH_ORG_DELETE_CONFIRM_DESC1: MvnCodeFE;
  AUTH_ORD_DELETE_CONFIRM_DESC2: MvnCodeFE;

  AUTH_ORG_UNSUBSCRIBE_PLAN_TITLE: MvnCodeFE;
  AUTH_ORG_UNSUBSCRIBE_PLAN_DESC: MvnCodeFE;
  AUTH_ORG_UNSUBSCRIBE_NOUN: MvnCodeFE;

  AUTH_ORG_CHANGE_OWNER_TITLE: MvnCodeFE;
  AUTH_ORG_CHANGE_OWNER_DESC: MvnCodeFE;
  AUTH_ORG_CHANGE_OWNER_SUCC: MvnCodeFE;
  AUTH_ORG_CHANGE_OWNER_FAIL: MvnCodeFE;

  AUTH_ORG_INVITE_RULE_SAME_DOMAIN_DESC: MvnCodeFE;
  AUTH_ORG_INVITE_RULE_OTHER_DOMAIN_DESC: MvnCodeFE;
  AUTH_ORG_INVITE_RULE_UPDATE_SUCC: MvnCodeFE;
  AUTH_ORG_INVITE_RULE_UPDATE_FAIL: MvnCodeFE;

  AUTH_ORG_INVITE_RULE_NOUN: MvnCodeFE;
  AUTH_ORG_INVITE_CANNOT_PROCEED_BY_RULE_DESC: MvnCodeFE;
} = {
  AUTH_ORGANIZATION_NOUN: {
    ko: "Organization",
    en: "Organization",
  },
  AUTH_ACCEPTED_NOUN: {
    ko: "Accepted",
    en: "Accepted",
  },
  AUTH_REJECTED_NOUN: {
    ko: "초대 거부",
    en: "Rejected",
  },
  AUTH_CANCEL_INVITATION_NOUN: {
    ko: "초대 취소",
    en: "Cancel Invitation",
  },

  AUTH_ORG_TAB_ORGANIZATION_LIST: {
    ko: "My Organizations",
    en: "My Organizations",
  },
  AUTH_ORG_TAB_INVITE: {
    ko: "Invitations",
    en: "Invitations",
  },

  AUTH_ORG_INVITATION_EMPTY_TITLE: {
    ko: "초대 내역이 없습니다.",
    en: "No Invitations.",
  },

  AUTH_ORG_INVITATION_POPUP_TITLE: {
    ko: "당신을 Organizations에 초대하였습니다.",
    en: "You have been invited to Organizations.",
  },
  AUTH_ORG_INVITATION_POPUP_DESC: {
    ko: "Invitations 탭에서 초대를 수락하시면 멤버로 등록됩니다.",
    en: "If you accept the invitation in the Invitations tab, you will be registered as a member.",
  },

  AUTH_ORG_INVITATION_CANCEL_TITLE: {
    ko: "{memberName}에게 보낸 Organization 초대를 취소하시겠습니까?",
    en: "Do you want to cancel the invitation sent to {memberName}?",
  },
  AUTH_ORG_INVITATION_CANCEL_DESC: {
    ko: "{memberName}에게 보낸 Organization 초대가 취소 됩니다.",
    en: "Once confirmed, the invitation sent to {memberName} will be canceled.",
  },

  AUTH_ORG_EMPTY_TITLE: {
    ko: "생성된 Organizations가 없습니다.",
    en: "No created organizations.",
  },
  AUTH_ORG_EMPTY_DESC: {
    ko: "Plan을 구독하기 위해서 Organization을 먼저 생성해주세요.",
    en: "Create an organization to subscribe a plan.",
  },

  AUTH_ORG_CREATE_TITLE: {
    ko: "Create an Organization",
    en: "Create an Organization",
  },
  AUTH_ORG_CREATE_ORGANIZATION_LABEL: {
    ko: "Organization 이름",
    en: "Organization Name",
  },
  AUTH_ORG_CREATE_ORGANIZATION_PLACEHOLDER: {
    ko: "Organization 이름을 입력해 주세요.",
    en: "Enter an organization name.",
  },
  AUTH_ORG_CREATE_SUCC: {
    ko: "Organization을 생성하였습니다.",
    en: "You have created a new organization successfully.",
  },
  AUTH_ORG_CREATE_FAIL: {
    ko: "Organization 생성에 실패하였습니다. ({message})",
    en: "You have failed to create a new organization. ({message})",
  },

  AUTH_ORG_RENAME_TITLE: {
    ko: "Organization 이름 변경",
    en: "Edit Organization Name",
  },
  AUTH_ORG_RENAME_ORGANIZATION_LABEL: {
    ko: "Organization 이름",
    en: "Organization Name",
  },
  AUTH_ORG_RENAME_ORGANIZATION_PLACEHOLDER: {
    ko: "Organization 이름을 입력해 주세요.",
    en: "Please enter an organization name.",
  },
  AUTH_ORG_RENAME_SUCC: {
    ko: "{name}이 수정 완료되었습니다.",
    en: "The {name} has been modified.",
  },
  AUTH_ORG_RENAME_FAIL: {
    ko: "{name} 수정에 실패하였습니다. ({message})",
    en: "Failed to modify {name}. ({message})",
  },
  AUTH_ORG_DELETE_TITLE: {
    ko: "Organization을 삭제 하시겠습니까?",
    en: "Delete the organization?",
  },
  AUTH_ORG_DELETE_DESC1: {
    ko: "{organization} 을(를) 삭제하시면, 해당 조직에 저장된 ",
    en: "If you delete the {organization}, ",
  },
  AUTH_ORG_DELETE_DESC2: {
    ko: "Study, Workspace, Room등 모든 데이터가 함께 삭제됩니다.",
    en: "all data stored in the organization, including Studies, Workspaces, and Rooms, will be deleted.",
  },
  AUTH_ORG_DELETE_SUCC: {
    ko: "{organization}이 삭제되었습니다.",
    en: "The {organization} has been deleted.",
  },
  AUTH_ORG_DELETE_FAIL: {
    ko: "{organization} 삭제에 실패하였습니다. ({message})",
    en: "Failed to delete the {organization}. ({message})",
  },
  AUTH_ORG_DELETE_CONFIRM_TITLE: {
    ko: "{organization}을(를) 영구적으로 삭제 하시겠습니까?",
    en: "Are you sure you want to permanently delete {organization}?",
  },
  AUTH_ORG_DELETE_CONFIRM_DESC1: {
    ko: "{plans}의 사용 기간이 아직 남아있습니다.",
    en: "The {plans} still have remaining usage time.",
  },
  AUTH_ORD_DELETE_CONFIRM_DESC2: {
    ko: "{organization}을(를) 삭제할 경우, 남은 사용 기간과 관계없이 해당 제품 사용이 즉시 중단됩니다.",
    en: "If you delete {organization}, all product usage will be terminated immediately, regardless of any remaining time.",
  },

  AUTH_ORG_UNSUBSCRIBE_PLAN_TITLE: {
    ko: "구독중인 플랜들을 해지하시겠습니까?",
    en: "Are you sure you want to cancel your subscription?",
  },
  AUTH_ORG_UNSUBSCRIBE_PLAN_DESC: {
    ko: "{organization}을(를) 삭제하기 전에 구독중인 플랜들을 먼저 해지하셔야 합니다.",
    en: "Before deleting {organization}, you must first cancel any subscriptions you have.",
  },
  AUTH_ORG_UNSUBSCRIBE_NOUN: {
    ko: "구독 해지",
    en: "Unsubscribe",
  },

  AUTH_ORG_CHANGE_OWNER_TITLE: {
    ko: "Organization Owner를 {name}으로 변경하시겠습니까?",
    en: "Change Organization Owner to {name}?",
  },
  AUTH_ORG_CHANGE_OWNER_DESC: {
    ko: "모든 구독정보와 결제수단, 권한이 {name}에게 이전되며, 현재 사용자는 Member 권한으로 변경됩니다.",
    en: "All subscription information, payment methods, and permissions will be transferred to {name}, and the current user will be changed to Member.",
  },
  AUTH_ORG_CHANGE_OWNER_SUCC: {
    ko: "Organization Owner 변경에 성공하였습니다.",
    en: "The organization Owner has been changed.",
  },
  AUTH_ORG_CHANGE_OWNER_FAIL: {
    ko: "Organization Owner 변경에 실패하였습니다. ({message})",
    en: "Failed to change the organization Owner. ({message})",
  },
  AUTH_ORG_INVITE_RULE_OTHER_DOMAIN_DESC: {
    ko: "다른 회사에 소속된 구성원을 Collaborator로 초대할 수 있습니다.",
    en: "Members from other companies can be invited as collaborators.",
  },
  AUTH_ORG_INVITE_RULE_SAME_DOMAIN_DESC: {
    ko: "같은 이메일 도메인을 사용하는 조직원만 초대할 수 있습니다.",
    en: "Only members using the same email domain can be invited.",
  },
  AUTH_ORG_INVITE_RULE_UPDATE_SUCC: {
    ko: "Invite Rule이 설정 되었습니다.",
    en: "Invite Rule has been updated.",
  },
  AUTH_ORG_INVITE_RULE_UPDATE_FAIL: {
    ko: "Invite Rule 설정에 실패하였습니다. ({message})",
    en: "Failed to update invite rule. ({message})",
  },
  AUTH_ORG_INVITE_RULE_NOUN: {
    ko: "멤버 초대 설정",
    en: "Invite Rule",
  },
  AUTH_ORG_INVITE_CANNOT_PROCEED_BY_RULE_DESC: {
    ko: "{organization}의 초대 규칙이 변경되어 초대를 수락할 수 없습니다.",
    en: "Your invitation cannot be accepted because the invitation rules for {organization} have changed.",
  },
};

MvnCodeInitiate(AUTH_ORGANIZATION_LANG);
